import { css } from 'styled-components';
import dt from '../../../shared/theme';

const easeOutQuad = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';

const AnimatedModal = css`
  @keyframes fadeIn {
    0% {
      transform: translateY(0);
    }

    1% {
      display: block;
      opacity: 0;
      transform: translateY(0);
    }

    100% {
      display: block;
      opacity: 1;
      transform: translateY(100%);
    }
  }

  animation: fadeIn 0.5s ${easeOutQuad};
  animation-fill-mode: forwards;
`;

const AnimatedCloseButton = css`
  @keyframes fadeIn {
    0% {
      display: none;
    }
  
    1% {
      display: block;
    }
    
    100% {
      display: block;
      opacity: 1;
    }
  }

  animation: fadeIn 0.2s ${easeOutQuad};
  animation-fill-mode: forwards;
`;

const PopUpModalStyles = css`
  box-sizing: border-box;
  box-shadow: 0px 20px 42px rgba(0, 0, 0, 0.09);
  overflow-y: visible;
  outline: none;
  display: none; 
  opacity: 0;

  & > article.horizontal {
    height: fit-content !important;
    border-radius: 4px;
    margin: 120px auto 0 auto;
    max-width: 90%;
    overflow-y: visible;
  }
  
  &.show {
    ${AnimatedModal};
  }

  button.close {
    background: transparent;
    border: none;
    outline: none;
    color: white;
    padding: 0;
    font-size: 48px;
    margin: -44px 0 0 0 !important;
  
    ${props => dt(props).theme.isMobileOrTablet && `
      margin: 20px 30px 0 12px;
    `};

    ${AnimatedCloseButton};
  }
`;

export {
  AnimatedModal,
  AnimatedCloseButton,
  PopUpModalStyles,
};
